var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'dp-textarea',
    {
      'dp-textarea--monospace': _vm.monospace,
      'dp-textarea--disabled': _vm.disabled,
    }
  ]},[_c('textarea',_vm._b({ref:"input",class:{
      'dp-textarea__inner': true,
      'dp-textarea__inner--disabled': _vm.disabled,
      'dp-textarea__inner--validation-error': _vm.v && _vm.v.$error,
    },style:({ resize: _vm.resize }),attrs:{"type":_vm.type,"spellcheck":_vm.spellcheck},domProps:{"value":_vm.currentValue},on:{"keydown":function($event){return _vm.keyEvent($event)},"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur,"drop":_vm.handleDrop,"scroll":_vm.handleScroll}},'textarea',_vm.$props,false)),(_vm.v && _vm.v.$error)?_c('dp-icon',{staticClass:"dp-textarea__validations",attrs:{"tooltip":_vm.autoErrorMessage,"name":"error"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }